import React from "react";

const Skeleton = () => {
  return (
    <div className="skeleton">
      <img className="skeleton__poster" alt=""></img>
      <div className="skeleton__title"></div>
    </div>
  );
};

export default Skeleton;
